<template>
    <h2 class="title" :style="{ color: project.colors.title }">
        <strong>{{ project.client }}</strong>
        <span>{{ project.title }}</span>
    </h2>
</template>

<script>
export default {
    props: {
        project: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style scoped lang="sass">
@import ~include-media/dist/include-media
@import ~styles/base

.title
    margin: 0 0 var(--line-base)
    line-height: 1 !important
    transform: translateY(10%)

    +media('<large')
        text-align: center


    +media('>=large')
        opacity: 0

    span
        font-size: 1.5rem

        +media('>=large')
            font-size: 3rem

    strong
        display: block


+media('>=large')
    .cover
        &:nth-child(odd)
            .title
                text-align: right
                grid-area: 1 / 1 / 2 / 2
                transform: translateX(10%)

        &:nth-child(even)
            .title
                grid-area: 1 / 2 / 2 / 3
                transform: translateX(-10%)
                
</style>
